"use client";

import { c as _c } from "react/compiler-runtime";
import { cx } from "@/lib/tailwind-utils";
interface EmptyServicesStateProps {
  message?: string;
  className?: string;
}
export const EmptyServicesState = t0 => {
  const $ = _c(7);
  const {
    message: t1,
    className
  } = t0;
  const message = t1 === undefined ? "No services match your criteria" : t1;
  let t2;
  if ($[0] !== className) {
    t2 = cx("py-16 text-center", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== message) {
    t3 = <p className="text-foreground-secondary">{message}</p>;
    $[2] = message;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = <div className={t2}>{t3}</div>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export default EmptyServicesState;